import type { OverviewMenuId, SamudkoyMenuId } from '../types'

export function getPageByMenu(menu: SamudkoyMenuId | OverviewMenuId): number {
  if (menu == 'menu1') return 3
  if (menu == 'menu2') return 20
  if (menu == 'menu3') return 34
  if (menu == 'menu4') return 61
  return 1
}
